import Scene from "~/scene";
import { htmlToImage } from "~/hti";
import { detect } from "detect-browser";
import { node } from "~/util/dom";
import { CONFIG } from "~/config";
import { getWasmScreenshot } from "./wasm";

function imageLoad(image: HTMLImageElement): Promise<boolean> {
	return new Promise(resolve => {
		image.addEventListener("load", () => resolve(true));
		image.addEventListener("error", () => resolve(false));
	});
}

async function prepareImage() {
	const outputData = {
		wasmImage: null,
	};
	const pano = Mapy.getComponent("pano");

	if (pano.isActive()) {
		const panoCont = pano.getContainer();
		const canvas = panoCont.querySelector("canvas");
		const browser = detect();
		const logos = Array.from(document.getElementById("all-controls").querySelectorAll(".control-mapy-logo"));

		logos.forEach(logo => {
			logo.classList.add("hidden");
		});

		if (browser.name === "safari") {
			const panoState = pano.getState();
			const pitch = panoState.pitch ? `&pitch=${panoState.pitch}` : "";
			const yaw = panoState.yaw ? `&yaw=${panoState.yaw}` : "";
			const src = `//panorama-mapserver.mapy.cz/compose_pano?w=${Math.min(1500, canvas.offsetWidth)}&h=${Math.min(1500, canvas.offsetHeight)}&pid=${panoState.pid}&fov=${panoState.fov}${pitch}${yaw}`;
			const img = node("img", { id: "panoPrintImg", src, width: canvas.offsetWidth, height: canvas.offsetHeight, crossOrigin: "anonymous" });
			const loadProm = imageLoad(img);

			img.style.position = "absolute";
			img.style.top = "0";
			img.style.left = "0";

			const loadData = await loadProm;

			if (loadData) {
				panoCont.insertBefore(img, panoCont.firstChild.nextSibling);
			}
		} else {
			try {
				const data = await pano.getDataUrl();

				if (canvas && data) {
					const img = node("img", { id: "panoPrintImg", src: data, width: canvas.offsetWidth, height: canvas.offsetHeight, crossOrigin: "anonymous" });

					img.style.position = "absolute";
					img.style.top = "0";
					img.style.left = "0";

					panoCont.insertBefore(img, panoCont.firstChild.nextSibling);
				}
			} catch (exc) {
				//
			}
		}
	} else if (Scene.isM3dActive()) {
		const img = node("img", { id: "m3dPrintImg", src: Scene.get3dScreenshot(false).src, crossOrigin: "anonymous" });

		img.style.position = "absolute";
		img.style.top = "0";
		img.style.left = "0";

		Scene.getContainer().appendChild(img);
	}

	if (CONFIG.wasmEnabled) {
		const wasmImage = await getWasmScreenshot();

		outputData.wasmImage = wasmImage;
	}

	return outputData;
}

function downloadAsImageRemoveLoader() {
	Mapy.getComponent("print").returnAfterPrint();

	if (Mapy.getComponent("loader").getBigCon().parentNode === document.body) {
		Mapy.getComponent("loader").getBigCon().remove();
	}

	Mapy.getComponent("loader").end(true);
}

export async function downloadAsImage() {
	// add loader
	document.body.appendChild(Mapy.getComponent("loader").getBigCon());
	Mapy.getComponent("loader").start(true);
	Mapy.getComponent("print").prepare(4);

	try {
		const prepareData = await prepareImage();
		const imgData = await htmlToImage();

		if (Mapy.getComponent("pano").isActive()) {
			const panoImgReplace = document.getElementById("panoPrintImg");

			panoImgReplace?.remove();
		}

		if (Scene.isM3dActive()) {
			const m3dImg = document.getElementById("m3dPrintImg");

			if (m3dImg) {
				m3dImg.remove();
			}
		}

		downloadAsImageRemoveLoader();
		Mapy.Util.startBlobDownload(Mapy.Util.dataURItoBlob(imgData), "mapy.png");

		if (prepareData.wasmImage) {
			prepareData.wasmImage.remove();
		}
	} catch (exc) {
		/* eslint-disable no-console */
		console.log(exc);
		downloadAsImageRemoveLoader();
	}
}
